<template>
  <page-outline :title="$t('profilesPage.edit_prfl')">
    <template slot="pageContent">
      <b-row class="pb-5 mx-0">
        <back-button :returnUrl="returnUrl"></back-button>
      </b-row>
      <form-accordion class="ml-3 mr-3" :title="$t('administration.company_details')"  :isTitleUpperCase="false">
        <b-row class="ml-5 mb-4 mr-5 mr-5 form-group">
          <b-col sm="5">
            <form-read-group-label-input
              :inputLabel="$t('common.idtfr')" :inputValue="accountLogin">
            </form-read-group-label-input>
          </b-col>
          <b-col sm="5">
            <form-read-group-label-input
              :inputLabel="$t('common.eml')" :inputValue="accountEmailReference">
            </form-read-group-label-input>
          </b-col>
        </b-row>
        <b-row class="ml-5 mb-4 mr-5 mr-5 form-group">
          <b-col sm="5">
            <form-write-group-label-input v-model="accountName" isMandatory
              :inputLabel="$t('common.nme')" :placeholder="editProfilePage_Name">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="5">
            <form-write-group-label-input v-model="accountAddress"
              :inputLabel="$t('common.adrs')" :placeholder="editProfilePage_Address">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row class="ml-5 mb-4 mr-5 mr-5 form-group">
          <b-col sm="5">
            <form-write-group-label-input v-model="accountCity"
              :inputLabel="$t('common.cty')" :placeholder="editProfilePage_City">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="5">
            <form-write-group-label-input v-model="accountZipCode"
              :inputLabel="$t('common.zp_code')" :placeholder="editProfilePage_ZipCode">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row class="ml-5 mb-4 mr-5 mr-5 form-group">
          <b-col sm="5">
            <form-write-group-label-input isMandatory
              :inputLabel="$t('administration.country')"
              :inputType="'listeSelect'">
              <select class="form-control" readonly v-model="accountCountry">
                <option value="">{{ $t('administration.country_select') }}</option>
                <option v-for="(country, index) in countries" :key="'select-country-option-' + index" :value="country">
                  {{country}}
                </option>
              </select>
            </form-write-group-label-input>
          </b-col>
          <b-col sm="5" v-if="accountType === '1'">
            <form-write-group-label-input v-model="accountLegalForm"
              :inputLabel="$t('common.lgl_frm')" :placeholder="editProfilePage_LegalForm">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row class="ml-5 mb-4 mr-5 mr-5 form-group ">
          <b-col sm="5" v-if="accountType === '1'">
            <form-write-group-label-input v-model="accountAmountOfCapital"
              :inputLabel="$t('common.shr_cptl')" :placeholder="editProfilePage_ShareCapital">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="5" v-if="accountType === '1'">
            <form-write-group-label-input v-model="accountIdentifierTVA"
              :inputLabel="$t('common.tva_nbr')" :placeholder="editProfilePage_TVAnumber">
            </form-write-group-label-input>
          </b-col>
        </b-row>
      </form-accordion>
      <form-accordion class="ml-3 mr-3" :title="$t('administration.company_details')"  :isTitleUpperCase="false">
        <b-row class="ml-5 mt-4 mb-4 mr-5 mr-5 form-group">
          <b-col sm="5">
            <form-write-group-label-input v-model="userLogin"
              :inputLabel="$t('administration.login')" :inputValue="userLogin ? userLogin : '-'">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="5">
            <form-write-group-label-input v-model="userName"
              :inputLabel="$t('common.nme')" :inputValue="userName ? userName : '-'">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row class="ml-5 mt-4 mb-4 mr-5 mr-5 form-group">
          <b-col sm="5">
            <form-read-group-label-input
              :inputLabel="$t('profilesPage.profile')" :inputValue="userProfile ? userProfile : '-'">
            </form-read-group-label-input>
          </b-col>
        </b-row>
      </form-accordion>
      <b-row class="form-group justify-content-end mr-5">
        <div sm="2">
          <b-button variant="primary" size="lg"
            @click="updateAccount">
            <i class="fa-light fa-floppy-disk"></i>
            <span>{{ $t('common.sve') }}</span>
          </b-button>
        </div>
      </b-row>
    </template>
  </page-outline>
</template>

<script>
import backButton from "@/components/common/backButton.vue"
// import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'

import countriesData from '@/pages/administration/data/countries.json'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  components: {
    'back-button': backButton,
    // 'bottom-toolbar': bottomToolbar,
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      countries: [],
      countriesData: countriesData.countries,
      isSmartphone: false,
      accountType: '',
      accountName: '',
      accountCompanyName: '',
      accountLogin: '',
      accountAddress: '',
      accountCity: '',
      accountZipCode: '',
      accountEmailReference: '',
      accountLegalForm: '',
      accountAmountOfCapital: '',
      accountIdentifierTVA: '',
      filterBy: '',
      accountCountry: '',
      returnUrl: '/profile/',
      userAccountInfo: {}
    }
  },
  computed: {
    filteredCountries () {
      let that = this
      let result = {}
      if (this.filterBy) {
        for (var k in that.countryAlphaTable) {
          for (var i = 0; i < that.countryAlphaTable[k].length; i++) {
            if (that.countryAlphaTable[k][i].toLowerCase().startsWith(this.filterBy.toLowerCase())) {
              if (!Object.hasOwn(result, k)) {
                result[k] = []
              }
              result[k].push(that.countryAlphaTable[k][i])
            }
          }
        }
        this.Dom7('li[class=hidden-by-searchbar]').each(function () {
          that.Dom7(this).removeClass('hidden-by-searchbar')
        })
        return result
      }

      return this.countryAlphaTable
    }
  },
  created () {
    for (let countryKey in this.countriesData) {
      this.countries.push(this.countriesData[countryKey].name)
    }
    this.editProfilePage_title = this.$i18n.t('profilesPage.edit_prfl')
    this.editProfilePage_Name = this.$i18n.t('common.nme')
    this.editProfilePage_Address = this.$i18n.t('common.adrs')
    this.editProfilePage_City = this.$i18n.t('common.cty')
    this.editProfilePage_ZipCode = this.$i18n.t('common.zp_code')
    this.editProfilePage_Country = this.$i18n.t('common.ctry')
    this.editProfilePage_LegalForm = this.$i18n.t('common.lgl_frm')
    this.editProfilePage_ShareCapital = this.$i18n.t('common.shr_cptl')
    this.editProfilePage_TVAnumber = this.$i18n.t('common.tva_nbr')
    this.editProfilePage_Search = this.$i18n.t('common.srch')
    if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isSmartphone = true
    }
    this.accountType = this.$engine.user.get().type

    this.accountName = this.$engine.user.get().name
    this.accountLogin = this.$engine.user.get().identifier
    this.accountEmailReference = this.$engine.user.get().email_reference
    this.accountAddress = this.$engine.user.get().address
    this.accountCity = this.$engine.user.get().city
    this.accountZipCode = this.$engine.user.get().zip_code
    this.accountCountry = this.$engine.user.get().country
    this.accountLegalForm = this.$engine.user.get().legalForm
    this.accountAmountOfCapital = this.$engine.user.get().amountOfCapital
    this.accountIdentifierTVA = this.$engine.user.get().identifierTVA
    this.getUserAccountInfo()
  },
  methods: {
    getUserAccountInfo () {
      let info = this.$engine.accounts.get()
      let userAccounts
      let userAccountId

      userAccounts = info[0].userAccts
      userAccountId = info[0].userAccountId
      userAccounts = userAccounts.filter((account) => account.id === userAccountId)
      this.updateUserAccountInfo(userAccounts)
    },
    updateAccount () {
      let that = this
      that.$engine.accounts.update({
        idAccount: that.$engine.user.get().id,
        name: that.accountName,
        type: that.accountType,
        address: that.accountAddress,
        city: that.accountCity,
        zip_code: that.accountZipCode,
        email_reference: that.$engine.user.get().email_reference,
        country: that.accountCountry,
        legalForm: that.accountLegalForm,
        amountOfCapital: that.accountAmountOfCapital,
        identifierTVA: that.accountIdentifierTVA
      })
      .then(response => {
        if (response.status === 200) {
          // return that.model.get()
          this.$bus.$emit('refresh-cache-menu')

          that.$f7.modal({
            title: 'Profile modified',
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            // that.$bus.$emit('refresh-cache-account-members')
            loadPage(that, {url: '/profile/', force: false, ignoreCache: false})
          }, 2000)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    profileCountryListPickerCloseButton () {
      if (this.Dom7('input[name=profileCountryPickerRadio]:checked').val() !== undefined) {
        this.accountCountry = this.Dom7('input[name=profileCountryPickerRadio]:checked').val()
      }
    },
    onSearch: function (query) {
      this.filterBy = query
    },
    onClear: function () {
      this.filterBy = ''
    },
    updateUserAccountInfo (userAccount) {
      this.userAccountInfo = userAccount
      this.userLogin = this.userAccountInfo[0].login
      this.userName = this.userAccountInfo[0].name
      this.userProfile = this.userAccountInfo[0].profile
    }
  }
}
</script>
<style scoped>
#profileSearchCountry {
  margin-top: 0;
}
.search {
  margin-left: 0px !important;
}
</style>
